import React from 'react'

const BlogContent = () => {
    return (
        <div className="catalog-tre-way">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="section-title"> <h2>Latest Blog</h2> </div>
                    </div>
                </div>
                <div className="row">  
                    <div className="col-md-4">  
                        <div className="blog-item">
                    
                            <div className="blog-img">
                            </div>
                            <div className="blog-content">
                                <h3><a href="#">Lorem ipsum dolor sit amet</a></h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam, quidem, tempora, vero.</p>
                                <a href="#" className="btn btn-default">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="blog-item">
                            <div className="blog-img">
                            </div>
                            <div className="blog-content">
                                <h3><a href="#">Lorem ipsum dolor sit amet</a></h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam, quidem, tempora, vero.</p>
                                <a href="#" className="btn btn-default">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="blog-item">
                            <div className="blog-img">
                            </div>
                            <div className="blog-content">
                                <h3><a href="#">Lorem ipsum dolor sit amet</a></h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam, quidem, tempora, vero.</p>
                                <a href="#" className="btn btn-default">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default BlogContent;
